/* eslint jsx-a11y/anchor-is-valid: 0 */
/* eslint react/jsx-no-target-blank: 0 */

import { useState, useEffect } from "react"
import queryString from 'query-string'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import Button from 'react-bootstrap-button-loader'
import Autosuggest from 'react-autosuggest'
import moment from 'moment'
import { Container, Row, Col } from 'react-bootstrap'
import Spinner from '../Components/Spinner'
import * as constant from '../constant'
import * as ajax from '../Utilities/ajax'
import Auth from "../Utilities/Auth"
import { getUrlQueries } from "../Utilities/url"
import { useHistory } from "react-router-dom"
import { BsPlusCircleFill } from 'react-icons/bs'
import NewMacroEco from "../Dialogs/NewMacroEco"
import { IconButton } from "@material-ui/core"
import { MdDeleteForever } from "react-icons/md"
import { BsPencil } from 'react-icons/bs'
import DeleteMacroEco from "../Dialogs/DeleteMacroEco"
import { LightTooltip } from "../Components/LigthTooptip"

const suggestionData = [
  { title: 'Title', list: [] },
  { title: 'Research Type', list: [] },
  { title: 'Author', list: [] },
]

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value) => {
  const escapedValue = escapeRegexCharacters(value.trim())

  if (escapedValue === '')
    return []

  // const regex = new RegExp('^' + escapedValue, 'i')
  const regex = new RegExp(escapedValue, 'i')

  return suggestionData
    .map(section => {
      return {
        title: section.title,
        list: section.list.filter(item => regex.test(item.value)).filter((_, i) => i < 10)
      }
    })
    .filter(section => section.list.length > 0)
}

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = (x) => x.value

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => <span>{suggestion.value}</span>
const renderSectionTitle = section => <strong>{section.title}</strong>
const getSectionSuggestions = section => section.list

const HEADER_LABEL = "Macroeconomics"

export default function MacroEco({ location }) {
  const history = useHistory()
  const canEdit = JSON.parse(sessionStorage.getItem('canEditMacroEco'))

  const [Loading, setLoading] = useState(false)
  const [label, setLabel] = useState(HEADER_LABEL)
  const [value, setValue] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [datas, setDatas] = useState([])
  const [columns, setColumns] = useState([{ dataField: "dummy", text: "" }])
  const [dialogMacroEco, setDialogMacroEco] = useState({ show: false, data: undefined })
  const [dialogDelete, setDialogDelete] = useState({ show: false, data: undefined })

  const onSuggestionsFetchRequested = ({ value }) => setSuggestions(getSuggestions(value))
  const onSuggestionsClearRequested = () => setSuggestions([])

  const handleSelectedSuggestion = (_, { suggestion }, records = datas) => {
    const searchKey = (suggestion.value || "").toLowerCase()

    const _datas = records.filter(x => (
      (x.searchTitle || "").toLowerCase().includes(searchKey)
      || (x.researchType || "").toLowerCase().includes(searchKey)
      || (x.author || "").toLowerCase().includes(searchKey)
    ))

    setLabel(suggestion.value)
    setValue(suggestion.value)
    setColumns([])
    setDatas(_datas)
    genColumns()
    history.push(`/macroeco?q=${suggestion.value}`)
  }

  const handleDetectView = async (item) => {
    return await ajax.post(
      "/macroeco/view",
      {
        username: Auth.getUserName(),
        macroEcoId: item.id,
      },
    )
  }

  const genColumns = () => {
    const _columns = [
      // Date
      {
        dataField: 'date',
        text: 'Date',
        headerStyle: { width: '100px' },
        style: { backgroundColor: 'white' },
        formatter: (c, r, i) => moment(c).format(constant.DATE_FORMAT),
      },
      // Title
      {
        dataField: 'title',
        text: 'Title',
        headerStyle: { width: '480px' },
        style: { backgroundColor: 'white' },
        formatter: (c, r, i) => {
          return (
            <div style={{ wordBreak: "break-word" }}>
              <a
                style={{ 'color': 'rgb(0,0,0)' }}
                target='_blank'
                onClick={() => handleDetectView(r)}
                href={`${constant.BASE_URL}/macroeco/download/${r.fileName}`}
              >
                {c}
              </a>
            </div>
          )
        },
      },
      // Author
      {
        dataField: 'author',
        text: 'Author',
        headerStyle: { width: '180px' },
        style: { backgroundColor: 'white' },
        formatter: (c, r, i) => <div style={{ wordBreak: "break-word" }}>{c}</div>,
      },
      // Research Type
      {
        dataField: 'researchType',
        text: 'Research Type',
        headerStyle: { width: '180px' },
        style: { backgroundColor: 'white' },
        formatter: (c, r, i) => <div style={{ wordBreak: "break-word" }}>{c}</div>,
      },
    ].concat(canEdit ? [
      // Action
      {
        dataField: 'action',
        text: 'Action',
        headerStyle: { width: '180px' },
        style: { backgroundColor: 'white' },
        formatter: (c, r, i) => {
          return (
            <div style={{ "textAlign": "left" }}>
              {/* Edit */}
              <LightTooltip
                title={"Edit"}
                aria-label="Edit"
              >
                <IconButton
                  aria-label="Edit"
                  style={{ padding: 0 }}
                  onClick={() => setDialogMacroEco({ show: true, data: r })}
                >
                  <BsPencil style={{ color: "#002560", fontSize: 20 }} />
                </IconButton>
              </LightTooltip>

              {/* Delete */}
              <div style={{ display: "inline", marginLeft: 8 }}>
                <LightTooltip
                  title={"Delete"}
                  aria-label="Delete"
                >
                  <IconButton
                    aria-label="Delete"
                    style={{ padding: 0 }}
                    onClick={() => setDialogDelete({ show: true, data: r })}
                  >
                    <MdDeleteForever style={{ color: "red", fontSize: 20 }} />
                  </IconButton>
                </LightTooltip>
              </div>
            </div>
          )
        }
      },
    ] : [])
    setColumns(_columns)
  }

  const reload = async (silent = false) => {
    if (!silent) {
      setLoading(true)
    }

    let results = []

    await ajax.get("/macroeco").then(result => {
      suggestionData[0].list = (result.data || {}).searchTitle || []
      suggestionData[1].list = (result.data || {}).researchType || []
      suggestionData[2].list = (result.data || {}).author || []

      results = (result.data || {}).data
      setDatas(results)

      const qStr = queryString.parse(location.search)
      const searchKey = qStr.search
      if (searchKey) { handleForcedSuggestion(searchKey) }
    }).catch(e => {
      console.log(e)
      alert("Error, please try again")
    })

    setLoading(false)

    return results
  }

  const handleForcedSuggestion = (searchKeyFromQstr) => {
    const searchKey = searchKeyFromQstr.toLowerCase()
    const _datas = datas.filter(d =>
      (d.title || "").toLowerCase().includes(searchKey)
      || (d.researchType || "").toLowerCase().includes(searchKey)
      || (d.author || "").toLowerCase().includes(searchKey)
    )
    setLabel(searchKeyFromQstr)
    setValue(searchKeyFromQstr)
    setColumns([])
    setDatas(_datas)
    genColumns()
  }

  const handleBack = () => {
    window.location.href = '/macroeco'
  }

  useEffect(() => {
    new Promise(async (r) => {
      genColumns()
      const results = await reload(false)

      const queries = getUrlQueries()
      if (queries.q) {
        handleSelectedSuggestion(undefined, { suggestion: { value: queries.q } } as any, results)
      }

      r(true)
    })

    // eslint-disable-next-line
  }, [])

  const inputProps = {
    placeholder: 'Filter by title, research type, author',
    value,
    onChange: (_, { newValue }) => setValue(newValue),
    disabled: label !== HEADER_LABEL,
  }

  return (
    <Container fluid className="container-macroeco elib" style={{ marginTop: -15, minHeight: "calc(100vh - 145px)" }}>
      {/* Report Title */}
      <Row>
        <Col>
          <p
            style={{
              paddingTop: 10,
              fontFamily: "Arial Narrow, Arial, sans-serif",
              fontSize: 20.8,
              fontWeight: "bolder",
              marginBottom: 6,
            }}
          >
            {label}
            {canEdit && (
              <BsPlusCircleFill
                style={{ cursor: "pointer", marginLeft: 8 }}
                onClick={() => setDialogMacroEco({ show: true, data: undefined })}
              />
            )}
          </p>
        </Col>
      </Row>

      {/* Back to all reports */}
      <Row>
        <Col>
          {label !== HEADER_LABEL &&
            <div style={{ textAlign: "left", paddingBottom: 10 }}>
              <Button variant="outline-secondary" onClick={handleBack}>{"Back to all research"}</Button>
            </div>
          }
        </Col>
      </Row>

      {/* Auto Suggestion */}
      <Row>
        <Col>
          <Autosuggest
            multiSection={true}
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSectionTitle={renderSectionTitle}
            getSectionSuggestions={getSectionSuggestions}
            inputProps={inputProps}
            onSuggestionSelected={handleSelectedSuggestion}
          />
        </Col>
      </Row>

      {/* Bootstrap Table */}
      <Row style={{ marginTop: 10 }}>
        <Col>
          {Loading && <Spinner />}
          {!Loading &&
            <BootstrapTable
              keyField='id'
              id="MacroEco"
              wrapperClasses="table-responsive"
              bootstrap4
              data={datas}
              columns={columns}
              pagination={paginationFactory({
                hidePageListOnlyOnePage: true,
                sizePerPage: 15,
                sizePerPageList: [15, 50, 100],
                hideSizePerPage: false,
              })}
            />
          }
        </Col>
      </Row>

      {/* Dialog */}
      <NewMacroEco
        open={dialogMacroEco}
        onClose={(shouldReload: boolean) => {
          const isEdit = !!dialogMacroEco.data
          setDialogMacroEco({ show: false, data: undefined })
          if (shouldReload) {
            reload(isEdit)
          }
        }}
      />
      <DeleteMacroEco
        open={dialogDelete}
        onClose={(shouldReload: boolean) => {
          setDialogDelete({ show: false, data: undefined })
          if (shouldReload) {
            reload(true)
          }
        }}
      />
    </Container>
  )
}
